import * as React from 'react';
import { TooltipToggleCore } from '@core-front/tooltip-toggle';
import Icon from '@telia-front/icon';
const TooltipToggle = React.forwardRef(function TooltipToggle(props, ref) {
    return (React.createElement(TooltipToggleCore, Object.assign({}, props, { components: {
            Icon,
        }, ref: ref }), props.children));
});
export { TooltipToggle as default };
